<div class="container-fluid px-3 py-3 text-xs">

  <!-- Header -->
  <div class="mb-3">
    <p class="text-muted mb-0">{{ page_subtitle }}</p>
  </div>

    <!-- Tabs -->
    <ul class="nav nav-tabs mb-3" role="tablist">
        <li v-for="tab in tabs" :key="tab.id" class="nav-item" role="presentation">
            <button
                class="nav-link fw-semibold small"
                :class="{ active: active_tab === tab.id }"
                type="button"
                role="tab"
                :aria-selected="active_tab === tab.id"
                @click="select_tab(tab.id)"
            >
                <i :class="['bi', tab.icon, 'me-2']"></i>{{ tab.label }}
            </button>
        </li>
    </ul>

  <!-- ========================= -->
  <!-- VIDEO TUTORIALS TAB -->
  <!-- ========================= -->
  <div v-if="active_tab === 'videos'" class="d-flex flex-column gap-4">

    <!-- Hero Card -->
    <div class="card border-primary shadow-sm rounded-4">
      <div class="card-body p-3 d-flex align-items-center gap-3">
        <div class="bg-success-subtle text-success rounded-4 p-3 d-flex align-items-center justify-content-center">
          <i class="bi bi-play-fill fs-4"></i>
        </div>
        <div>
          <h6 class="fw-semibold mb-1">{{ hero_card.title }}</h6>
          <p class="text-muted mb-0">{{ hero_card.subtitle }}</p>
        </div>
      </div>
    </div>

    <!-- Video Cards -->
    <div class="row g-3">
      <div
        v-for="video in video_playlists"
        :key="video.id"
        class="col-md-4 col-lg-3"
      >
        <div class="card border-primary h-100  shadow-sm rounded-4">
          <div class="card-body p-3 d-flex flex-column h-100">

            <!-- Badge + Duration -->
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="badge bg-warning-subtle text-warning rounded-pill text-xs">
                {{ video.category }}
              </span>
              <span class="badge bg-light text-muted rounded-pill text-xs">
                {{ video.duration }}
              </span>
            </div>

            <!-- Video Preview -->
            <div class="ratio ratio-16x9 bg-success-subtle rounded-4 d-flex align-items-center justify-content-center mb-3">
              <div class="bg-white rounded-4 shadow-sm p-3 d-flex align-items-center justify-content-center">
                <i class="bi bi-play-fill fs-4 text-success"></i>
              </div>
            </div>

            <!-- Content -->
            <h6 class="fw-semibold mb-1">{{ video.title }}</h6>
            <p class="text-muted small mb-0">{{ video.description }}</p>

          </div>
        </div>
      </div>
    </div>

    <!-- Insights -->
    <div class="card border-primary shadow-sm rounded-4">
      <div class="card-body p-4">
        <div class="d-flex align-items-center gap-2 mb-3">
          <div class="bg-info-subtle text-info rounded-4 p-2 d-flex align-items-center justify-content-center">
            <i class="bi bi-lightbulb"></i>
          </div>
          <div>
            <h6 class="fw-semibold mb-0">{{ insights_card.title }}</h6>
            <p class="text-muted small mb-0">{{ insights_card.subtitle }}</p>
          </div>
        </div>

        <div class="row g-3">
          <div
            v-for="insight in insights_card.items"
            :key="insight.id"
            class="col-md-4"
          >
            <div class="card  border-primary h-100 rounded-4">
              <div class="card-body p-3">
                <h6 class="fw-semibold mb-1">{{ insight.title }}</h6>
                <p class="text-muted small mb-0">{{ insight.description }}</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- ========================= -->
  <!-- SUPPORT TICKETS TAB -->
  <!-- ========================= -->
  <div v-else-if="active_tab === 'tickets'" class="d-flex flex-column gap-4">

    <!-- Quick Tips -->
    <div class="card border-primary shadow-sm rounded-4">
      <div class="card-body p-4">
        <div class="d-flex align-items-center gap-2 mb-3">
          <div class="bg-warning-subtle text-warning rounded-4 p-2 d-flex align-items-center justify-content-center">
            <i class="bi bi-journal-bookmark"></i>
          </div>
          <div>
            <h6 class="fw-semibold mb-0">{{ quick_tips.title }}</h6>
            <p class="text-muted small mb-0">{{ quick_tips.subtitle }}</p>
          </div>
        </div>

        <div class="row g-3">
          <div
            v-for="tip in quick_tips.items"
            :key="tip.id"
            class="col-md-4"
          >
            <div class="card  bg-light h-100 rounded-4">
              <div class="card-body p-3">
                <h6 class="fw-semibold mb-1">{{ tip.title }}</h6>
                <p class="text-muted small mb-0">{{ tip.description }}</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Stats + Action -->
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-3">
      <div class="row g-3 flex-grow-1">
        <div
          v-for="stat in support_stats"
          :key="stat.id"
          class="col-sm-6 col-lg-3"
        >
          <div class="card border-primary shadow-sm rounded-4 h-100">
            <div class="card-body d-flex align-items-center gap-3">
              <div
                class="rounded-4 p-3 d-flex align-items-center justify-content-center"
                :class="stat.icon_bg_class"
              >
                <i :class="['bi', stat.icon, stat.icon_color_class, 'fs-4']"></i>
              </div>
              <div>
                <div class="fw-semibold h6 mb-0">{{ stat.count }}</div>
                <div class="text-muted small mb-0">{{ stat.label }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button class="btn btn-primary btn-sm rounded-3 d-flex align-items-center gap-1">
        <i class="bi bi-plus"></i>
        {{ support_card.primary_action }}
      </button>
    </div>

    <!-- Empty State -->
    <div class="card border-primary shadow-sm rounded-4">
      <div class="card-body p-4 text-center">
        <div class="display-6 text-secondary mb-2">
          <i :class="['bi', support_empty.icon_class]"></i>
        </div>
        <h6 class="fw-semibold mb-1 text-secondary">{{ support_empty.title }}</h6>
        <p class="text-muted mb-0">{{ support_empty.description }}</p>
      </div>
    </div>

  </div>
</div>
